import { T } from "../../util/t";

export const PrivacyPolicy = () =>
    <div id="privacy_policy" className="wrapper">
        <T>PrivacyPolicy_LocalizedComponent</T>
    </div>;
